module.exports = __webpack_public_path__ + "img/jisuanqi.5348ff65.png";